import { getConfigWith } from '@hox/frontend-utils/appConfig';

const getAuthConfig = (cfg: { [key: string]: string }) => ({
  i18nCdnUrl: cfg['i18n-cdn-url'],
  reactAppBackendBaseUrl: cfg['backend-base-url'],
});

export const config = getConfigWith(getAuthConfig)('app-config');
